import React from 'react';

import ClientRenderedContent from '@components/ClientRenderedContent';
import { dateInLocalTimezone } from '@utils/dates';

const SubscriptionInfo = ({ billingDate, billingAmount, currentPlanType }) => {
  return (
    <div className="max-w-[624px] text-left">
      <h1 className="font-suisse-works text-headline-xxs sm:text-headline-lg">
        Subscription Information
      </h1>
      <p className="subscription-info-detail">
        Your next cycle begins on{' '}
        <ClientRenderedContent>
          <span className="subscription-info-detail-value">
            {dateInLocalTimezone(billingDate)}.
          </span>
        </ClientRenderedContent>{' '}
        {currentPlanType === 'monthly' ? (
          <>
            You will be charged{' '}
            <span className="subscription-info-detail-value">{billingAmount}</span> plus applicable
            taxes.
          </>
        ) : (
          <>
            Your next renewal price will be communicated to you in your renewal notification prior
            to renewing.
          </>
        )}
      </p>
    </div>
  );
};

export default SubscriptionInfo;
